"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const Layout_1 = __importDefault(require("./components/Layout"));
const react_router_dom_1 = require("react-router-dom");
const HelloPage_1 = __importDefault(require("./pages/HelloPage"));
const SimplifiedResume_1 = __importDefault(require("./pages/SimplifiedResume"));
require("./index.css");
const App = () => (react_1.default.createElement(react_router_dom_1.HashRouter, null,
    react_1.default.createElement(Layout_1.default, null,
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(HelloPage_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/resume", element: react_1.default.createElement(SimplifiedResume_1.default, null) })))));
const container = document.getElementById("app");
if (!container) {
    throw new Error("Root container missing in index.html");
}
const root = client_1.default.createRoot(container);
root.render(react_1.default.createElement(react_1.default.StrictMode, null,
    react_1.default.createElement(App, null)));
